export enum LayoutPaddingToken {
  spacingInsetNone = '0',
  spacingInsetQuarck = '0.4rem',
  spacingInsetNano = '0.8rem',
  spacingInsetXs = '1.6rem',
  spacingInsetSm = '2.4rem',
  spacingInsetMd = '3.2rem',
  spacingInsetLg = '4.0rem',
  spacingInsetXl = '4.8rem',
}

export default LayoutPaddingToken

export type TPadding =
  | 'spacingInsetNone'
  | 'spacingInsetQuarck'
  | 'spacingInsetNano'
  | 'spacingInsetXs'
  | 'spacingInsetSm'
  | 'spacingInsetMd'
  | 'spacingInsetLg'
  | 'spacingInsetXl'
